module.exports = __webpack_public_path__ + "img/6.e713df44.jpg";